import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { AGENT_STATUS_STYLES, type AgentStatus } from '@/lib/mock-agents-data';

export function AgentStatusBadge({ status, className }: { status: AgentStatus; className?: string }) {
  return (
    <Badge variant="outline" className={cn('text-[9px]', AGENT_STATUS_STYLES[status], className)}>
      {status}
    </Badge>
  );
}
